// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.expert-title {
  background-image: url("/assets/img/expert-bg.png");
  background-size: cover;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 16px;
  /* 關注 */
  /* 已關注 */
}
.expert-title a.expert-link {
  text-decoration: none;
  color: inherit;
  display: flex;
  flex: 1;
  cursor: pointer;
}
.expert-title a.expert-link:hover {
  text-decoration: none;
}
.expert-title a.expert-link:visited {
  color: inherit;
}
.expert-title .avatar ion-avatar {
  width: calc(64 / var(--base-width) * 100vw);
  height: calc(64 / var(--base-width) * 100vw);
  border: 1px;
  border-color: var(--ion-color-primary-tint);
  border-style: solid;
}
.expert-title .author-desc {
  margin-left: calc(8 * var(--width-ratio));
  flex: 1;
  padding-top: calc(7 * var(--width-ratio));
  padding-bottom: calc(7 * var(--width-ratio));
}
.expert-title .author-desc .title {
  display: inline-block;
}
.expert-title .author-desc img {
  width: 24px;
  height: 24px;
  display: inline-block;
  margin-left: 6px;
}
.expert-title .non-follow-btn {
  --background: var(--ion-color-primary-tint);
  width: calc(68 * var(--width-ratio));
  height: calc(24 * var(--width-ratio));
  margin: unset;
  --padding-end: unset;
  --padding-start: unset;
}
.expert-title .follow-btn {
  --background: white !important;
  --border-color: var(--ion-color-medium);
  --color: var(--ion-color-medium);
  --border-style: solid;
  --border-width: 1px;
  clear: both;
  width: calc(84 * var(--width-ratio));
  height: calc(24 * var(--width-ratio));
  margin: unset;
  --padding-end: unset;
  --padding-start: unset;
}
.expert-title .statis-div {
  padding-left: 16px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.expert-title .statis-div div {
  display: inline-block;
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/expert-title/expert-title.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,kDAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EA8CA,OAAA;EAaA,QAAA;AAvDF;AADE;EACE,qBAAA;EACA,cAAA;EACA,aAAA;EACA,OAAA;EACA,eAAA;AAGJ;AADI;EACE,qBAAA;AAGN;AAAI;EACE,cAAA;AAEN;AAGI;EACE,2CAAA;EACA,4CAAA;EACA,WAAA;EACA,2CAAA;EACA,mBAAA;AADN;AAKE;EACE,yCAAA;EACA,OAAA;EACA,yCAAA;EACA,4CAAA;AAHJ;AAKI;EACE,qBAAA;AAHN;AAKI;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;AAHN;AAQE;EACE,2CAAA;EACA,oCAAA;EACA,qCAAA;EAIA,aAAA;EACA,oBAAA;EACA,sBAAA;AATJ;AAaE;EACE,8BAAA;EACA,uCAAA;EACA,gCAAA;EACA,qBAAA;EACA,mBAAA;EAGA,WAAA;EACA,oCAAA;EACA,qCAAA;EAEA,aAAA;EACA,oBAAA;EACA,sBAAA;AAdJ;AAiBE;EACE,kBAAA;EACA,iBAAA;EACA,oBAAA;AAfJ;AAiBI;EACE,qBAAA;EACA,kBAAA;AAfN","sourcesContent":[".expert-title {\n  background-image: url(\"/assets/img/expert-bg.png\");\n  background-size: cover;\n  padding-left: 16px;\n  padding-right: 16px;\n  padding-top: 16px;\n\n  // SEO 優化：將作者資訊包裝在 a 標籤內\n  a.expert-link {\n    text-decoration: none;\n    color: inherit;\n    display: flex;\n    flex: 1;\n    cursor: pointer;\n\n    &:hover {\n      text-decoration: none;\n    }\n\n    &:visited {\n      color: inherit;\n    }\n  }\n\n  .avatar {\n    ion-avatar {\n      width: calc(64 / var(--base-width) * 100vw);\n      height: calc(64 / var(--base-width) * 100vw);\n      border: 1px;\n      border-color: var(--ion-color-primary-tint);\n      border-style: solid;\n    }\n  }\n\n  .author-desc {\n    margin-left: calc(8 * var(--width-ratio));\n    flex: 1;\n    padding-top: calc(7 * var(--width-ratio));\n    padding-bottom: calc(7 * var(--width-ratio));\n\n    .title {\n      display: inline-block;\n    }\n    img {\n      width: 24px;\n      height: 24px;\n      display: inline-block;\n      margin-left: 6px;\n    }\n  }\n\n  /* 關注 */\n  .non-follow-btn {\n    --background: var(--ion-color-primary-tint);\n    width: calc(68 * var(--width-ratio));\n    height: calc(24 * var(--width-ratio));\n\n    // margin-top: calc(2 * var(--width-ratio));\n    // margin-right: 26px;\n    margin: unset;\n    --padding-end: unset;\n    --padding-start: unset;\n  }\n\n  /* 已關注 */\n  .follow-btn {\n    --background: white !important;\n    --border-color: var(--ion-color-medium);\n    --color: var(--ion-color-medium);\n    --border-style: solid;\n    --border-width: 1px;\n    // margin: 2px 0 0 0;\n    // margin-right: 26px;\n    clear: both;\n    width: calc(84 * var(--width-ratio));\n    height: calc(24 * var(--width-ratio));\n\n    margin: unset;\n    --padding-end: unset;\n    --padding-start: unset;\n  }\n\n  .statis-div {\n    padding-left: 16px;\n    padding-top: 10px;\n    padding-bottom: 10px;\n\n    div {\n      display: inline-block;\n      margin-right: 10px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
